import { AttendedEvents, EarnedBadges } from '@account/routes/AccountEvents/tabs';
import { Tabs } from '@components/utility/tabs';
import { Box, Divider, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useSearchParams } from 'react-router-dom';

enum EventTabs {
    Attended = 'attended-events',
    EarnedBadges = 'earned-badges',
}

export const AccountEvents = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const tabParam = searchParams.get('tab');
    const tab = tabParam !== null ? tabParam : EventTabs.Attended;

    return (
        <>
            <title>My events - Victron Professional</title>
            <Box bgcolor="#fff" className="black-border" borderRadius="5px" p="24px">
                <Typography py="26px" fontFamily="museo-sans" letterSpacing="-1%" fontSize="26px">
                    <FormattedMessage id="events.title" defaultMessage="Events" />
                </Typography>
                <Divider />
                <Tabs
                    value={tab}
                    onChange={(_, value) => {
                        searchParams.set('tab', value.toString());
                        setSearchParams(searchParams);
                    }}
                    boxProps={{ my: '24px' }}
                >
                    <Tabs.Tab
                        value={EventTabs.Attended}
                        label={<FormattedMessage id="events.attended" defaultMessage="Attended Events" />}
                    />
                    <Tabs.Tab
                        value={EventTabs.EarnedBadges}
                        label={<FormattedMessage id="events.earnedBadges" defaultMessage="Earned Badges" />}
                    />
                </Tabs>
                {tab === EventTabs.Attended && <AttendedEvents />}
                {tab === EventTabs.EarnedBadges && <EarnedBadges />}
            </Box>
        </>
    );
};
